import { environment } from '../../../environments/environment';
import { User } from '@models/user.model';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import 'rxjs/add/operator/map';
import { TableConfig } from '@app/shared/util/table-config.utils';
import { AppUtils } from '@app/shared/util/app.utils';
import { EmdEmployee } from '@models/emd-employee.model';
import { PagedResponse } from '@models/response.model';
import { UserRole } from '@models/role.model';
import { map } from "rxjs/operators";

@Injectable()
export class UserService {
    static readonly API_USERS_BASE_PATH = `${environment.baseURL}/api/users`;
    static readonly API_ROLES_BASE_PATH = `${environment.baseURL}/api/roles`;

    roles = new Array<UserRole>();

    constructor(private http: HttpClient) {
        this.getUserRoles();
    }

    getUsers(tableConfig: TableConfig = null) {
        const params = AppUtils.buildPageableParams(tableConfig);

        return this.http.get<PagedResponse<User>>(`${UserService.API_USERS_BASE_PATH}`, {
            params: params
        }).pipe(map(this.mapUsers));
    }

    getUserRoles() {
        return this.http.get(`${UserService.API_ROLES_BASE_PATH}`)
            .pipe(map(this.mapUserRoles));
    }

    updateUser(user, data) {
        return this.http.put(`${UserService.API_USERS_BASE_PATH}/${user.id}`, data);
    }

    searchEmdEmployees(searchTerm: string) {
        return this.http.get<any[]>(`${UserService.API_USERS_BASE_PATH}/emd-employees`, {
            params: {searchTerm: searchTerm}
        }).pipe(map((items: any[]) => items.map(item => new EmdEmployee(item))));
    }

    registerEmdUser(payload: { badgeId: number | null; userBusinessType: string }) {
        return this.http.post(`${UserService.API_USERS_BASE_PATH}/emd-employees/register`, payload)
            .pipe(map((user: any) => new User(user)));
    }

    resetUser(user: User) {
        return this.http.post(`${UserService.API_USERS_BASE_PATH}/${user.id}/reset`, {});
    }

    deleteUser(user: User) {
        return this.http.delete(`${UserService.API_USERS_BASE_PATH}/${user.id}`, {})
    }

    private mapUsers = res => {
        return {
            users: res.items.map(user => new User(user)),
            count: res.total
        };
    }

    private mapUserRoles = res => {
        return {
            items: res.items.map(role => {
                return new UserRole(role);
            }),
            count: res.total
        };
    }

    getSelectedPlants(id: number) {
        return this.http.get<number[]>(`${UserService.API_USERS_BASE_PATH}/${id}/plants`);
    }

    setSelectedPlants(id: number, plantIds: number[]) {
        return this.http.put(`${UserService.API_USERS_BASE_PATH}/${id}/plants`, plantIds);
    }

}
